import { FC } from "react";

import { Box } from "@mui/material";
import { format, parseISO } from "date-fns";
import { isEmpty } from "lodash";
import BalanceStatusBadge from "src/Pages/Company/Absences/AbsenceRequest/BalanceStatusBadge";
import { BillingCycleConfigurationType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";
import { IAbsenceTypeBalances } from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";

interface IAbsenceRequestBalancesProps {
  billingCycleType: BillingCycleConfigurationType | null | undefined;
  balanceData: IAbsenceTypeBalances;
  displayMonths: {
    from: string;
    to: string;
  };
}

const AbsenceRequestBalances: FC<IAbsenceRequestBalancesProps> = ({
  billingCycleType,
  balanceData,
  displayMonths,
}) => {
  const { from, to } = displayMonths;
  let dates = new Set();

  if (!billingCycleType) {
    return <BalanceStatusBadge labelUT="Dostępne" color="success.dark" />;
  }

  if (billingCycleType === BillingCycleConfigurationType.Yearly) {
    const startDate = parseISO(from).getFullYear().toString();
    const endDate = parseISO(to).getFullYear().toString();

    dates = new Set([startDate, endDate]);
  }

  if (billingCycleType === BillingCycleConfigurationType.Monthly) {
    if (!balanceData) {
      dates = new Set();

      return null;
    }

    const cycles = balanceData.balanceStatuses
      .map((balance) => balance.billingCycle)
      .sort((a, b) => a.localeCompare(b));

    dates = new Set(cycles);
  }

  if (!balanceData || isEmpty(dates)) return null;

  return (
    <>
      {Array.from(dates).map((date) => {
        const currentBalance = balanceData.balanceStatuses.find(
          (balance) => balance.billingCycle === date
        );

        if (!currentBalance) return null;

        const label =
          billingCycleType === BillingCycleConfigurationType.Monthly
            ? format(parseISO(date as string), "MM.yyyy")
            : date;

        return (
          <Box key={date as string} sx={{ minWidth: "330px" }}>
            <BalanceStatusBadge
              labelUT={`Dostępne w ${label}`}
              days={currentBalance.totalAvailableTimeAmount?.days}
              hours={currentBalance.totalAvailableTimeAmount?.hours}
              overdueDays={currentBalance.overdueAvailableTimeAmount?.days}
              overdueHours={currentBalance.overdueAvailableTimeAmount?.hours}
              color="success.dark"
            />
          </Box>
        );
      })}
    </>
  );
};

export default AbsenceRequestBalances;
